import Connect from './connect.svg';
import Corner from './corner.svg';
import Disconnect from './disconnect.svg';
import Round from './round.svg';
import Sharp from './sharp.svg';
import Smooth from './smooth.svg';
import Symmetry from './symmetry.svg';

export default {
  Connect,
  Corner,
  Disconnect,
  Round,
  Sharp,
  Smooth,
  Symmetry,
};
